import { ComponentInstall } from "../../utils";
import SearchInput from "./src";

export default ComponentInstall(SearchInput);
